<template>
  <basic-page
    title="Muonituksen asetukset"
    :prev="true"
    :fallback="{ name: 'Muonitus' }"
  >
    <template v-slot:app-bar-buttons>
      <v-btn icon title="Tallenna" @click="saveSettings" :loading="saving">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
    </template>
    <v-row>
      <v-col cols="12" md="6">
        <v-card class="mb-4 elevation-2">
          <v-card-title class="py-3">
            <v-icon left color="primary">mdi-shape</v-icon>
            Kategoriat
            <v-spacer></v-spacer>
            <v-btn
              small
              text
              color="primary"
              @click="seedDefaults"
              v-if="categories.length === 0 && eventTypes.length === 0"
              >Palauta oletukset</v-btn
            >
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-list dense class="grey lighten-5 rounded mb-4">
              <v-list-item v-for="(cat, i) in categories" :key="i">
                <v-list-item-content>
                  <div class="font-weight-medium">{{ cat }}</div>
                </v-list-item-content>
                <v-list-item-action class="d-flex flex-row">
                  <v-btn icon small @click="moveCategory(i, -1)"
                    ><v-icon>mdi-arrow-up</v-icon></v-btn
                  >
                  <v-btn icon small @click="moveCategory(i, 1)"
                    ><v-icon>mdi-arrow-down</v-icon></v-btn
                  >
                  <v-btn icon small color="red" @click="removeCategory(i)"
                    ><v-icon>mdi-delete</v-icon></v-btn
                  >
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider class="mb-4"></v-divider>
            <div class="text-subtitle-2 mb-2">Lisää uusi kategoria</div>
            <v-row dense align="center">
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="newCategory"
                  label="Kategorian nimi"
                  dense
                  outlined
                  hide-details
                  @keyup.enter="addCategory"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn
                  color="primary"
                  block
                  @click="addCategory"
                  :disabled="!newCategory"
                  >Lisää</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveSettings" :loading="saving"
              >Tallenna</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card class="mb-4 elevation-2">
          <v-card-title class="py-3">
            <v-icon left color="primary">mdi-clipboard-check</v-icon>
            Varustelista (Checklist)
            <v-spacer></v-spacer>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-list dense class="grey lighten-5 rounded mb-4">
              <v-list-item
                v-for="(item, index) in checklistItems"
                :key="item._ui_id"
                :class="{
                  'pl-8': item.indent,
                  'grey lighten-4': draggedIndex === index,
                }"
                draggable="true"
                @dragstart="onDragStart(index, $event)"
                @dragover.prevent
                @dragenter.prevent="onDragEnter(index)"
                @dragend="onDragEnd"
              >
                <v-list-item-avatar
                  class="ma-0 mr-2 align-self-center"
                  style="cursor: move"
                  title="Raahaa järjestääksesi"
                >
                  <v-icon>mdi-drag</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-row dense align="center">
                    <v-col cols="12" sm="5">
                      <v-text-field
                        v-model="item.label"
                        dense
                        outlined
                        hide-details
                        background-color="white"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="3">
                      <v-checkbox
                        v-model="item.indent"
                        label="Sisennys"
                        dense
                        hide-details
                        class="mt-0"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="item.defaultChecked"
                        label="Oletusvalinta"
                        dense
                        hide-details
                        class="mt-0 caption"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6" sm="3" class="d-flex justify-end">
                      <v-btn
                        icon
                        small
                        color="red"
                        @click="removeChecklistItem(index)"
                        ><v-icon>mdi-delete</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-divider class="mb-4"></v-divider>
            <div class="text-subtitle-2 mb-2">Lisää uusi rivi</div>
            <v-row dense align="center">
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="newChecklistItem.label"
                  label="Nimi"
                  dense
                  outlined
                  hide-details
                  @keyup.enter="addChecklistItem"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="3">
                <v-checkbox
                  v-model="newChecklistItem.indent"
                  label="Sisennys"
                  dense
                  hide-details
                  class="mt-0"
                ></v-checkbox>
                <v-checkbox
                  v-model="newChecklistItem.defaultChecked"
                  label="Oletusvalinta"
                  dense
                  hide-details
                  class="mt-0 caption"
                ></v-checkbox>
              </v-col>
              <v-col cols="6" sm="3">
                <v-btn
                  color="primary"
                  block
                  small
                  @click="addChecklistItem"
                  :disabled="!newChecklistItem.label"
                  >Lisää</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveSettings" :loading="saving"
              >Tallenna</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="mb-4 elevation-2">
          <v-card-title class="py-3">
            <v-icon left color="primary">mdi-calendar-clock</v-icon>
            Tapahtumatyypit
            <v-spacer></v-spacer>
            <v-btn icon color="primary" @click="addEventType"
              ><v-icon>mdi-plus</v-icon></v-btn
            >
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-expansion-panels
              accordion
              flat
              class="grey lighten-5 rounded mb-4"
            >
              <v-expansion-panel
                v-for="(type, i) in eventTypes"
                :key="i"
                class="mb-1"
              >
                <v-expansion-panel-header class="font-weight-medium">
                  {{ type.name }} ({{ type.price }} €)
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat color="transparent">
                    <v-card-text class="pa-0">
                      <v-row dense>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="type.name"
                            label="Nimi"
                            outlined
                            dense
                            background-color="white"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="type.id"
                            label="ID"
                            disabled
                            outlined
                            dense
                            background-color="white"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model.number="type.price"
                            label="Hinta (€)"
                            type="number"
                            outlined
                            dense
                            background-color="white"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            v-model="type.description"
                            label="Kuvaus"
                            rows="2"
                            outlined
                            dense
                            background-color="white"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-btn
                        color="error"
                        text
                        small
                        @click="removeEventType(i)"
                        >Poista</v-btn
                      >
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-expand-transition>
              <div v-if="showNewTypeForm" class="grey lighten-4 pa-4 rounded">
                <div class="text-subtitle-1 mb-2">Uusi tapahtumatyyppi</div>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="newType.name"
                      label="Nimi"
                      outlined
                      dense
                      background-color="white"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="newType.id"
                      label="ID (pienillä, ei välejä)"
                      outlined
                      dense
                      background-color="white"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model.number="newType.price"
                      label="Hinta (€)"
                      type="number"
                      outlined
                      dense
                      background-color="white"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="newType.description"
                      label="Kuvaus"
                      rows="2"
                      outlined
                      dense
                      background-color="white"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <div class="d-flex mt-2">
                  <v-btn
                    color="primary"
                    @click="saveNewEventType"
                    :disabled="!newType.name || !newType.id"
                    class="mr-2"
                    >Lisää</v-btn
                  >
                  <v-btn text @click="showNewTypeForm = false">Peruuta</v-btn>
                </div>
              </div>
            </v-expand-transition>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveSettings" :loading="saving"
              >Tallenna</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card class="mb-4 elevation-2">
          <v-card-title class="py-3">
            <v-icon left color="primary">mdi-food</v-icon>
            Menut
            <v-spacer></v-spacer>
            <v-btn icon color="primary" @click="addMenuClick"
              ><v-icon>mdi-plus</v-icon></v-btn
            >
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-expansion-panels
              accordion
              flat
              class="grey lighten-5 rounded mb-4"
            >
              <v-expansion-panel
                v-for="(menu, i) in menus"
                :key="i"
                class="mb-1"
              >
                <v-expansion-panel-header class="font-weight-medium">
                  {{ menu.name }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat color="transparent">
                    <v-card-text class="pa-0">
                      <v-row dense>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="menu.name"
                            label="Nimi"
                            outlined
                            dense
                            background-color="white"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-select
                            v-model="menu.templateId"
                            :items="templates"
                            item-text="name"
                            item-value="id"
                            label="Kauppalistapohja"
                            clearable
                            outlined
                            dense
                            background-color="white"
                          ></v-select>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea
                            v-model="menu.description"
                            label="Kuvaus / Sisältö"
                            rows="2"
                            outlined
                            dense
                            background-color="white"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-btn color="error" text small @click="removeMenu(i)"
                        >Poista</v-btn
                      >
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-expand-transition>
              <div v-if="showNewMenuForm" class="grey lighten-4 pa-4 rounded">
                <div class="text-subtitle-1 mb-2">Uusi menu</div>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="newMenu.name"
                      label="Nimi"
                      outlined
                      dense
                      background-color="white"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="newMenu.templateId"
                      :items="templates"
                      item-text="name"
                      item-value="id"
                      label="Kauppalistapohja"
                      clearable
                      outlined
                      dense
                      background-color="white"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="newMenu.description"
                      label="Kuvaus / Sisältö"
                      rows="2"
                      outlined
                      dense
                      background-color="white"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <div class="d-flex mt-2">
                  <v-btn
                    color="primary"
                    @click="saveNewMenu"
                    :disabled="!newMenu.name"
                    class="mr-2"
                    >Lisää</v-btn
                  >
                  <v-btn text @click="showNewMenuForm = false">Peruuta</v-btn>
                </div>
              </div>
            </v-expand-transition>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveSettings" :loading="saving"
              >Tallenna</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card class="mb-4 elevation-2" v-if="templateCount === 0">
          <v-card-title class="primary white--text py-3">
            <v-icon left color="white">mdi-database-plus</v-icon>
            Kauppalistapohjien alustus
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <p>Luo oletuskauppalistapohjat tietokantaan.</p>
            <v-btn
              color="secondary"
              @click="seedTemplates"
              :loading="seedingTemplates"
              >Luo oletuskauppalistapohjat</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </basic-page>
</template>

<script>
import BasicPage from "@/components/BasicPage.vue";
import { firestore as db } from "@/plugins/firebase.app";
import {
  doc,
  getDoc,
  setDoc,
  collection,
  addDoc,
  getDocs,
} from "firebase/firestore";

export default {
  name: "MuonitusAsetukset",
  components: { BasicPage },
  data() {
    return {
      categories: [],
      eventTypes: [],
      checklistItems: [],
      menus: [],
      templates: [],
      templateCount: 0,
      newCategory: "",
      newMenu: {
        name: "",
        description: "",
        templateId: null,
      },
      saving: false,
      showNewTypeForm: false,
      showNewMenuForm: false,
      newType: {
        id: "",
        name: "",
        price: 0,
        description: "",
      },
      newChecklistItem: {
        label: "",
        indent: false,
        defaultChecked: false,
      },
      draggedIndex: null,
      seedingTemplates: false,
    };
  },
  async created() {
    await this.fetchSettings();
  },
  methods: {
    async fetchSettings() {
      const docRef = doc(db, "catering_settings", "general");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        this.categories = data.categories || [];
        this.eventTypes = data.eventTypes || [];
        this.checklistItems = (data.checklistItems || []).map((item) => ({
          ...item,
          _ui_id:
            item._ui_id ||
            Date.now() +
              Math.random().toString(36).substr(2, 9) +
              Math.random(),
        }));

        // Normalize menus to objects
        this.menus = (data.menus || []).map((m) => {
          if (typeof m === "string") {
            return { name: m, description: "", templateId: null };
          }
          return m;
        });
      }

      const templatesSnap = await getDocs(collection(db, "catering_templates"));
      this.templateCount = templatesSnap.size;
      this.templates = templatesSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
    },
    async saveSettings() {
      this.saving = true;
      try {
        await setDoc(doc(db, "catering_settings", "general"), {
          categories: this.categories,
          eventTypes: this.eventTypes,
          checklistItems: this.checklistItems,
          menus: this.menus,
        });
        this.$toast("Asetukset tallennettu", { type: "success" });
      } catch (e) {
        console.error(e);
        this.$toast("Virhe tallennuksessa", { type: "error" });
      } finally {
        this.saving = false;
      }
    },
    addCategory() {
      if (this.newCategory && !this.categories.includes(this.newCategory)) {
        this.categories.push(this.newCategory);
        this.newCategory = "";
      }
    },
    async removeCategory(index) {
      if (
        await this.$confirm("Haluatko varmasti poistaa kategorian?", {
          title: "Poista kategoria",
          color: "red",
        })
      ) {
        this.categories.splice(index, 1);
      }
    },
    moveCategory(index, direction) {
      if (index + direction < 0 || index + direction >= this.categories.length)
        return;
      const temp = this.categories[index];
      this.$set(this.categories, index, this.categories[index + direction]);
      this.$set(this.categories, index + direction, temp);
    },
    addEventType() {
      this.showNewTypeForm = true;
      this.newType = { id: "", name: "", price: 0, description: "" };
    },
    saveNewEventType() {
      this.eventTypes.push({ ...this.newType });
      this.showNewTypeForm = false;
    },
    async removeEventType(index) {
      if (
        await this.$confirm("Haluatko varmasti poistaa tämän tyypin?", {
          title: "Poista tapahtumatyyppi",
          color: "red",
        })
      ) {
        this.eventTypes.splice(index, 1);
      }
    },
    addMenuClick() {
      this.showNewMenuForm = true;
      this.newMenu = { name: "", description: "", templateId: null };
    },
    saveNewMenu() {
      this.menus.push({ ...this.newMenu });
      this.showNewMenuForm = false;
    },
    async removeMenu(index) {
      if (
        await this.$confirm("Haluatko varmasti poistaa tämän menun?", {
          title: "Poista menu",
          color: "red",
        })
      ) {
        this.menus.splice(index, 1);
      }
    },
    moveMenu(index, direction) {
      if (index + direction < 0 || index + direction >= this.menus.length)
        return;
      const temp = this.menus[index];
      this.$set(this.menus, index, this.menus[index + direction]);
      this.$set(this.menus, index + direction, temp);
    },
    addChecklistItem() {
      if (this.newChecklistItem.label) {
        this.checklistItems.push({
          ...this.newChecklistItem,
          _ui_id: Date.now() + Math.random().toString(36).substr(2, 9),
        });
        this.newChecklistItem.label = "";
        this.newChecklistItem.indent = false;
        this.newChecklistItem.defaultChecked = false;
      }
    },
    async removeChecklistItem(index) {
      if (
        await this.$confirm("Haluatko varmasti poistaa rivin?", {
          title: "Poista rivi",
          color: "red",
        })
      ) {
        this.checklistItems.splice(index, 1);
      }
    },
    moveChecklistItem(index, direction) {
      if (direction === -1 && index > 0) {
        const item = this.checklistItems.splice(index, 1)[0];
        this.checklistItems.splice(index - 1, 0, item);
      } else if (direction === 1 && index < this.checklistItems.length - 1) {
        const item = this.checklistItems.splice(index, 1)[0];
        this.checklistItems.splice(index + 1, 0, item);
      }
    },
    onDragStart(index, event) {
      this.draggedIndex = index;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.dropEffect = "move";
    },
    onDragEnter(index) {
      if (this.draggedIndex !== null && this.draggedIndex !== index) {
        const item = this.checklistItems.splice(this.draggedIndex, 1)[0];
        this.checklistItems.splice(index, 0, item);
        this.draggedIndex = index;
      }
    },
    onDragEnd() {
      this.draggedIndex = null;
    },
    async seedDefaults() {
      this.categories = [
        "HeVi",
        "Leipä",
        "Kuivatuotteet",
        "Maitotuotteet",
        "Juomat",
        "Tarvikkeet",
        "Muu",
      ];
      this.eventTypes = [
        {
          id: "halytys_1",
          name: "Hälytys (1. aalto / Kahvi)",
          price: 6.5,
          description: "Sisältää: Kahvi ja sämpylä",
        },
        {
          id: "halytys_2",
          name: "Hälytys (2. aalto / Ruoka)",
          price: 8.65,
          description: "Sisältää: Lounas (lämmin ruoka, juoma, kahvi)",
        },
        {
          id: "harjoitus",
          name: "Harjoitus",
          price: 6.5,
          description: "Sisältää: Kahvi ja sämpylä",
        },
        {
          id: "kurssi",
          name: "Kurssi",
          price: 8.65,
          description: "Sisältää: Lounas (lämmin ruoka, juoma, kahvi)",
        },
        {
          id: "kokous",
          name: "Kokous",
          price: 4.3,
          description: "Sisältää: Kahvi ja pulla",
        },
        {
          id: "tapahtuma",
          name: "Tapahtuma",
          price: 1.6,
          description: "Sisältää: Makkara",
        },
        { id: "muu", name: "Muu", price: 0, description: "" },
      ];
      this.checklistItems = [
        { label: "Muonituslaatikot", indent: false },
        { label: "mukit", indent: true },
        { label: "jätesäkit", indent: true },
        { label: "käsidesi", indent: true },
        { label: "tarvikkeet", indent: true },
        { label: "Kanisterit", indent: false },
        { label: "mehu", indent: true },
        { label: "vesi", indent: true },
        { label: "käsienpesu", indent: true },
        { label: "Termarit", indent: false },
        { label: "kahvi", indent: true },
        { label: "teevesi", indent: true },
        { label: "Kylmä/lämpölaatikot (1-2kpl)", indent: false },
        { label: "Taittopöydät (1-2kpl)", indent: false },
        { label: "Telttakatos", indent: false },
        { label: "Ilmakaariteltta", indent: false },
        { label: "Lämmittimet", indent: true },
        { label: "Valaistus (pimeään aikaan)", indent: false },
        { label: "Muonitukseen tarvittava vaatetus", indent: false },
        { label: "Käsipaperit", indent: false },
      ];
      await this.saveSettings();
    },
    async seedChecklistDefaults() {
      if (
        !confirm(
          "Tämä korvaa nykyisen varustelistan oletuksilla. Haluatko jatkaa?"
        )
      )
        return;
      this.checklistItems = [
        { label: "Muonituslaatikot", indent: false },
        { label: "mukit", indent: true },
        { label: "jätesäkit", indent: true },
        { label: "käsidesi", indent: true },
        { label: "tarvikkeet", indent: true },
        { label: "Kanisterit", indent: false },
        { label: "mehu", indent: true },
        { label: "vesi", indent: true },
        { label: "käsienpesu", indent: true },
        { label: "Termarit", indent: false },
        { label: "kahvi", indent: true },
        { label: "teevesi", indent: true },
        { label: "Kylmä/lämpölaatikot (1-2kpl)", indent: false },
        { label: "Taittopöydät (1-2kpl)", indent: false },
        { label: "Telttakatos", indent: false },
        { label: "Ilmakaariteltta", indent: false },
        { label: "Lämmittimet", indent: true },
        { label: "Valaistus (pimeään aikaan)", indent: false },
        { label: "Muonitukseen tarvittava vaatetus", indent: false },
        { label: "Käsipaperit", indent: false },
      ];
      await this.saveSettings();
    },
    async seedTemplates() {
      this.seedingTemplates = true;
      const templates = [
        {
          name: "Hälytysmuonitus (Perus)",
          items: [
            {
              name: "Kahvi",
              amount: 0,
              unit: "pkt",
              category: "Muu",
              factor: 0.05,
              fixed: false,
            },
            {
              name: "Maito",
              amount: 0,
              unit: "l",
              category: "Maitotuotteet",
              factor: 0.1,
              fixed: false,
            },
            {
              name: "Sokeri",
              amount: 0,
              unit: "pkt",
              category: "Kuivatuotteet",
              factor: 0.02,
              fixed: false,
            },
            {
              name: "Sämpylä",
              amount: 0,
              unit: "kpl",
              category: "Leipä",
              factor: 2,
              fixed: false,
            },
            {
              name: "Margariini",
              amount: 0,
              unit: "pkt",
              category: "Maitotuotteet",
              factor: 0.05,
              fixed: false,
            },
            {
              name: "Leikkele",
              amount: 0,
              unit: "pkt",
              category: "Muu",
              factor: 0.1,
              fixed: false,
            },
            {
              name: "Juusto",
              amount: 0,
              unit: "pkt",
              category: "Maitotuotteet",
              factor: 0.1,
              fixed: false,
            },
            {
              name: "Kurkku",
              amount: 0,
              unit: "kpl",
              category: "HeVi",
              factor: 0.2,
              fixed: false,
            },
            {
              name: "Suolakurkku",
              amount: 0,
              unit: "prk",
              category: "Kuivatuotteet",
              factor: 0.05,
              fixed: false,
            },
            {
              name: "Laimennettava mehu",
              amount: 0,
              unit: "pll",
              category: "Juomat",
              factor: 0.05,
              fixed: false,
            },
          ],
        },
        {
          name: "Keittolounas",
          items: [
            {
              name: "Keitto",
              amount: 0,
              unit: "l",
              category: "Muu",
              factor: 0.4,
              fixed: false,
            },
            {
              name: "Leipä",
              amount: 0,
              unit: "kpl",
              category: "Leipä",
              factor: 2,
              fixed: false,
            },
            {
              name: "Levite",
              amount: 0,
              unit: "rs",
              category: "Maitotuotteet",
              factor: 0.05,
              fixed: false,
            },
            {
              name: "Juoma",
              amount: 0,
              unit: "l",
              category: "Juomat",
              factor: 0.3,
              fixed: false,
            },
            {
              name: "Kahvi",
              amount: 0,
              unit: "pkt",
              category: "Muu",
              factor: 0.05,
              fixed: false,
            },
          ],
        },
        {
          name: "Makkaranpaisto",
          items: [
            {
              name: "Makkara",
              amount: 0,
              unit: "pkt",
              category: "Muu",
              factor: 0.25,
              fixed: false,
            },
            {
              name: "Sinappi",
              amount: 1,
              unit: "pll",
              category: "Kuivatuotteet",
              factor: 1,
              fixed: true,
            },
            {
              name: "Ketsuppi",
              amount: 1,
              unit: "pll",
              category: "Kuivatuotteet",
              factor: 1,
              fixed: true,
            },
            {
              name: "Mehu",
              amount: 0,
              unit: "l",
              category: "Juomat",
              factor: 0.3,
              fixed: false,
            },
          ],
        },
      ];

      try {
        const colRef = collection(db, "catering_templates");
        for (const t of templates) {
          await addDoc(colRef, t);
        }
        this.templateCount = templates.length;
        this.$toast("Kauppalistapohjat luotu", { type: "success" });
      } catch (e) {
        console.error(e);
        this.$toast("Virhe kauppalistapohjien luonnissa", { type: "error" });
      } finally {
        this.seedingTemplates = false;
      }
    },
  },
};
</script>
